import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../PlantDesignDetails.module.scss';
import { FormGroup, Input } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import { PlantDesignDetailsPage } from 'plantDesign/constants/plantDesignDetailsPage';
import { PlantDesignRefData } from 'plantDesign/constants/PlantDesignRefData';

export const ConcretePlacingBoomDesignDetails = React.forwardRef((props, ref) => {
  const { maxBoomLength: savedMaxBoomLength = '', maxBoomHeight: savedMaxBoomHeight = '' } = props.value || {};

  const [maxBoomLength, setMaxBoomLength] = useState(savedMaxBoomLength);
  const [maxBoomHeight, setMaxBoomHeight] = useState(savedMaxBoomHeight);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const REF_CONSTANTS = PlantDesignRefData.concretePlacingBoom;
  const PAGE_CONSTANTS = PlantDesignDetailsPage.concretePlacingBoom;

  const validators = [
    {
      fieldName: 'maxBoomLength',
      fieldValue: maxBoomLength,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxBoomHeight',
      fieldValue: maxBoomHeight,
      isValid: (v) => isNumeric(v) || props.subType !== REF_CONSTANTS.mobileOrTruckMountedTypeValue,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        const isValid = validateExt(validators, setErrors, setErrorSummary);
        setShowErrors(!isValid);
        return isValid;
      },
    };
  }

  useEffect(() => {
    const details = {
      maxBoomLength,
      maxBoomHeight,
    };
    props.onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [maxBoomLength, maxBoomHeight]);

  useEffect(() => {
    props.onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <FormGroup
        id="maxBoomLength"
        label={PAGE_CONSTANTS.maxBoomLength.label}
        helpMessage={PAGE_CONSTANTS.maxBoomLength.helpMessage}
        isRequired
        errorMessage={errors?.maxBoomLength?.errorMessage}
        hasError={showErrors && errors?.maxBoomLength?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxBoomLength.suffix}
          onChange={(e) => setMaxBoomLength(e.target.value)}
          value={maxBoomLength}
          inputWidth="md"
        />
      </FormGroup>

      {props.subType === REF_CONSTANTS.mobileOrTruckMountedTypeValue && (
        <FormGroup
          id="maxBoomHeight"
          label={PAGE_CONSTANTS.maxBoomHeight.label}
          helpMessage={PAGE_CONSTANTS.maxBoomHeight.helpMessage}
          isRequired
          errorMessage={errors?.maxBoomHeight?.errorMessage}
          hasError={showErrors && errors?.maxBoomHeight?.invalid}
          className={styles.inputWithSuffix}
          margin={{ top: 'md' }}
        >
          <Input
            suffix={PAGE_CONSTANTS.maxBoomHeight.suffix}
            onChange={(e) => setMaxBoomHeight(e.target.value)}
            value={maxBoomHeight}
            inputWidth="md"
          />
        </FormGroup>
      )}
    </>
  );
});

ConcretePlacingBoomDesignDetails.displayName = 'ConcretePlacingBoomDesignDetails';

ConcretePlacingBoomDesignDetails.propTypes = {
  subType: PropTypes.string,
  value: PropTypes.object,
  refData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onErrorChange: PropTypes.func.isRequired,
};
